import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink
              href="https://goo.gl/maps/9kEgm3GGz8DPWXNr7"
              target="_blank"
            >
              <CFImage src={mobileMap} w="100%" alt="Masita Korean Cuisine" />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink
              href="https://goo.gl/maps/9kEgm3GGz8DPWXNr7"
              target="_blank"
            >
              <CFImage src={locationMap} w="100%" alt="Masita Korean Cuisine" />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
